import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "page-inner" }
const _hoisted_2 = { class: "banner" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "video"
}
const _hoisted_5 = ["src", "poster"]
const _hoisted_6 = { class: "recommend" }
const _hoisted_7 = { class: "inner" }
const _hoisted_8 = {
  key: 0,
  class: "title"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "container" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "item-inner" }
const _hoisted_13 = { class: "img" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "info" }
const _hoisted_16 = { class: "btn" }
const _hoisted_17 = {
  key: 1,
  class: "image-list"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["src"]
const _hoisted_20 = ["src"]
const _hoisted_21 = ["src"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h4", null, "活动规则", -1)
const _hoisted_23 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "page-home page",
    style: _normalizeStyle({'background-image': _ctx.templateConfig.bg ? 'url('+ _ctx.templateConfig.bg +')' : ''})
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: _ctx.templateConfig.banner,
          alt: ""
        }, null, 8, _hoisted_3)
      ]),
      (_ctx.templateConfig.videoUrl)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("video", {
              src: _ctx.templateConfig.videoUrl,
              poster: _ctx.templateConfig.videoPoster + '?imageView2/2/w/640',
              controls: "",
              playsinline: "",
              "webkit-playsinline": "true",
              "mtt-playsinline": "true",
              "raw-controls": ""
            }, null, 8, _hoisted_5)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "recommend-item",
            key: index
          }, [
            _createElementVNode("div", _hoisted_7, [
              (item.img)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("img", {
                      src: item.img,
                      alt: ""
                    }, null, 8, _hoisted_9)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_10, [
                (_ctx.templateConfig.type !== 'image')
                  ? (_openBlock(), _createElementBlock("ul", {
                      key: 0,
                      style: _normalizeStyle({'background-color': _ctx.templateConfig.goodsBgColor || ''})
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.goods, (goodsItem) => {
                        return (_openBlock(), _createElementBlock("li", {
                          style: _normalizeStyle({'border-color': _ctx.templateConfig.borderColor || ''}),
                          key: goodsItem.goodsId,
                          onClick: ($event: any) => (_ctx.goGoods(goodsItem))
                        }, [
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("img", {
                                src: goodsItem.image + '?imageMogr2/auto-orient/thumbnail/!333x187r/gravity/Center/crop/333x187|imageslim',
                                alt: ""
                              }, null, 8, _hoisted_14)
                            ]),
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("h5", {
                                style: _normalizeStyle({'color': _ctx.templateConfig.titleColor || ''})
                              }, _toDisplayString(goodsItem.title), 5),
                              _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("span", {
                                  style: _normalizeStyle({'background-color': _ctx.templateConfig.themeColor || '', 'color': _ctx.templateConfig.btnFontColor || ''})
                                }, _toDisplayString(_ctx.templateConfig.btnText || '兑 换'), 5)
                              ])
                            ])
                          ])
                        ], 12, _hoisted_11))
                      }), 128))
                    ], 4))
                  : (_openBlock(), _createElementBlock("ul", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.goods, (goodsItem) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: goodsItem.goodsId,
                          onClick: ($event: any) => (_ctx.goGoods(goodsItem))
                        }, [
                          _createElementVNode("img", {
                            src: goodsItem.image,
                            alt: ""
                          }, null, 8, _hoisted_19)
                        ], 8, _hoisted_18))
                      }), 128))
                    ]))
              ])
            ])
          ]))
        }), 128))
      ]),
      (_ctx.templateConfig.topicId && _ctx.templateConfig.topicImg)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "topic",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goTopic(_ctx.templateConfig.topicId)))
          }, [
            _createElementVNode("img", {
              src: _ctx.templateConfig.topicImg,
              alt: ""
            }, null, 8, _hoisted_20)
          ]))
        : _createCommentVNode("", true),
      (_ctx.templateConfig.ruleImg)
        ? (_openBlock(), _createElementBlock("img", {
            key: 2,
            src: _ctx.templateConfig.ruleImg,
            alt: ""
          }, null, 8, _hoisted_21))
        : _createCommentVNode("", true),
      (_ctx.templateConfig.rule)
        ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            class: "rule",
            style: _normalizeStyle({'color': _ctx.templateConfig.ruleColor || ''})
          }, [
            _hoisted_22,
            _createElementVNode("div", {
              class: "content",
              innerHTML: _ctx.templateConfig.rule
            }, null, 8, _hoisted_23)
          ], 4))
        : _createCommentVNode("", true)
    ])
  ], 4))
}